export { default as default } from './BlocDeContinguts';
